import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../Header/index";
import { Global, css } from "@emotion/react";
import { Box } from "@mui/joy";

const DashboardLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Global
                styles={css`
                    body {
                        margin: 0;
                        padding: 0;
                        overflow-x: hidden;
                        -webkit-text-size-adjust: 100%;
                    }

                    html,
                    body {
                        position: relative;
                        height: 100%;
                    }

                    .layout-container {
                        display: flex;
                        flex-direction: column;
                        min-height: 100vh;
                        width: 100%;
                    }

                    .content-area {
                        margin-top: var(--Header-height);
                        -webkit-overflow-scrolling: touch;
                        padding-bottom: 20px;
                    }
                `}
            />
            <Box className="layout-container">
                <Header />
                <Box
                    component="main"
                    className="content-area"
                    sx={{
                        flex: 1,
                        background: (theme) =>
                            theme.palette.mode === "dark"
                                ? "radial-gradient(ellipse at top, rgba(66, 171, 155, 0.04) 0%, transparent 60%)"
                                : "radial-gradient(ellipse at top, rgba(66, 171, 155, 0.06) 0%, transparent 60%)",
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </>
    );
};

export default DashboardLayout;
